import { render } from "./SucursalForm-Component.vue?vue&type=template&id=9d72fa5c"
import script from "./SucursalForm-Component.vue?vue&type=script&lang=js"
export * from "./SucursalForm-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__